/**
 *
 */

import {PaymentStatus, ActionTypes} from 'store/actions/payment';

/**
 * Status logic for state change.
 *
 * @param {Object} state - State of the component.
 * @param {Object} action - Payload for the action.
 * @returns {Object} Next state of the component.
 */
function status (state = PaymentStatus.INITIAL, action) {

    switch (action.type) {

        case ActionTypes.SET_PAYMENT_STATUS:
            return action.status;

        default:
            return state;
    }
}

/**
 * Error logic for state change.
 *
 * @param {Object} state - State of the component.
 * @param {Object} action - Payload for the action.
 * @returns {Object} Next state of the component.
 */
function error (state = '', action) {

    switch (action.type) {

        case ActionTypes.SET_PAYMENT_ERROR:
            return action.formError || '';

        default:
            return state;
    }
}

/**
 * Payment reducer.
 *
 * @param {Object} state - State of the component.
 * @param {Object} action - Action payload.
 * @returns {Object} Payment reducer.
 */
export default function payment (state = {}, action) {

    return {
        status: status(state.status, action),
        error: error(state.error, action)
    };
}


// WEBPACK FOOTER //
// ./src/js/store/reducers/payment.js